import React from "react"

function Button(props) {
  return (
    <td className="shop-cart__discount-button" onClick={props.onClick}>
      {props.value}
    </td>
  );
}

class Keyboard extends React.Component {
  renderButton(i) {
    return (
      <Button
        value={i}
        onClick={() => this.props.onSetDiscount({type: this.props.type, amount: i })}
      />
    );
  }

  render() {
    return (
      <table className="shop-cart__discount-keyboard">
        <tbody>
          <tr>
            {this.renderButton(1)}
            {this.renderButton(2)}
            {this.renderButton(3)}
          </tr>
          <tr>
            {this.renderButton(4)}
            {this.renderButton(5)}
            {this.renderButton(6)}
          </tr>
          <tr>
            {this.renderButton(7)}
            {this.renderButton(8)}
            {this.renderButton(9)}
          </tr>
          <tr>
            {this.renderButton(0)}
            <td className="shop-cart__discount-button shop-cart__discount-keyboard-cancel"
                onClick={this.props.onCorrectDiscount}>
            </td>
            <td className="shop-cart__discount-button shop-cart__discount-keyboard-done"
                onClick={this.props.onRequestClose}>
              Done
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

export default Keyboard
